import get from 'lodash/get';
import fireNotification from '../utils/fireNotification';
import { logoutRedirect } from '../components/common/ErrorHandler/messageActions';

const handleGraphQLMutationErrors = (error, errorMessage, langCode) => {
  const statusCode = get(error, 'networkError.statusCode');

  if (statusCode === 401) {
    logoutRedirect();
  } else {
    fireNotification(errorMessage, langCode);
  }
};

export default handleGraphQLMutationErrors;
